import React, { useState, useEffect } from "react";
import Cookies from "universal-cookie";

const Consent = () => {
  const cookies = new Cookies();
  const gaProperty = "UA-XXXX-Y";
  const key = `ga-disable-${gaProperty}`;

  const expiryTime = () => {
    var current = new Date();
    var expiry = 30; // Days until the cookie expires
    current.setTime(current.getTime() + 24 * expiry * 60 * 60 * 1e3);
    return current; // This should be current, not a new Date object
  };

  const options = { path: "/", expires: expiryTime() };

  const [item, setItem] = useState(() => cookies.get(key) || null);
  const [showConsent, setShowConsent] = useState(false);

  useEffect(() => {
    if (item === null) {
      setTimeout(() => {
        setShowConsent(true);
      }, 2000);
    }
  }, [item]);

  const acceptCookies = () => {
    setShowConsent(false);
    cookies.set(key, false, options);
    setItem(false); // Update state
  };

  const declineCookies = () => {
    setShowConsent(false);
    cookies.set(key, true, options);
    setItem(true); // Update state
  };

  const closeConsent = () => {
    setShowConsent(false);
    cookies.set(key, false, options);
    setItem(false); // Update state
  };

  return (
    <>
      {item === null && showConsent && (
        <div className="consent-bar">
          <div className="text">
            By using this website, you understand that we use cookies for
            limited purposes. What for?{" "}
            <a href={"/privacy/"} style={{ color: "white" }}>
              Privacy Policy
            </a>
            .&nbsp;
            <div>
              <span className="button" onClick={declineCookies}>
                Decline
              </span>
              &nbsp;
              <span className="button" onClick={acceptCookies}>
                Accept
              </span>
            </div>
          </div>
          <img
            className="close-consent"
            onClick={closeConsent}
            src={"/images/close.svg"}
            width="20"
            height="20"
            alt="Close"
          />
        </div>
      )}
    </>
  );
};

export default Consent;
